<template>
	<v-layout wrap 
		class="section-information"
		:style="`background-color:${$appColors.primary}`">
		<v-flex xs12 mb-3>
			<div class="wrapper-user-image">
				<div class="wrapper-user">
					<img 
						:src="urlImage" 
						alt="user"
						height="100%"
						width="100%">
				</div>
				<div class="wrapper-camera" v-if="isEdit">
					<load-input
						:show-input="false"
						icon="camera_alt"
						color="white"
						class-btn="circle-btn"
						@input="getImage"
					/>
				</div>
			</div>
		</v-flex>
		<v-flex xs12>
			<p class="mb-5 text">{{ fullName }}</p>
		</v-flex>
		<v-flex xs12>
			<p 
				class="text"
				:class="{'f-600': $route.name === 'profile'}">PERFIL</p>
		</v-flex>
		<v-flex xs12 text-xs-center>
			<button 
				@click="changePassword"
				:class="{'f-600': $route.name === 'password-edit'}">CAMBIAR CONTRASEÑA</button>
		</v-flex>
	</v-layout>
</template>
<script>
import loadInput from '@/components/shared/load-file-input';
import { mapGetters, mapState } from 'vuex';

function created() {
	this.urlImage = this.avatar ? this.avatar : 'https://praktiko-main.s3.us-east-1.amazonaws.com/iconos/Icons+sidebar/user-null.svg';
}

function getImage(url) {
	this.urlImage = url;
	this.$emit('change-image', this.urlImage);
}

function changePassword() {
	this.goTo('password-edit');
}

function data() {
	return {
		urlImage: '',
	};
}
export default {
	name: 'section-information',
	components: {
		loadInput,
	},
	created,
	computed: {
		...mapGetters([
			'fullName',
		]),
		...mapState({
			avatar: state => state.user.urlImage,
		}),
	},
	methods: {
		getImage,
		changePassword,
	},
	data,
	props: {
		isEdit: {
			type: Boolean,
			default: false,
		},
	},
};

</script>
<style lang="scss" scoped>
	.section-information {
		align-content: flex-start;
		align-items: flex-start;
		border: 1px solid color(gray);
		border-radius: 4px;
		box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.02);
		color: color(white);
		height: 100%;
		margin-left: auto;
		max-width: 245px;
		min-height: 490px;
		padding: 26px 36px;
	}

	.wrapper-user {
		border-radius: 50%;
		height: 100px;
		margin: auto;
		overflow: hidden;
		width: 100px;
	}

	.text {
		font-size: size(large);
		text-align: center;
	}

	.wrapper-user-image {
		position: relative;
	}

	.wrapper-camera {
		bottom: -1px;
		position: absolute;
		right: 13px;
	}

	.f-600 {
		font-weight: 600;
	}
</style>


// WEBPACK FOOTER //
// src/components/user/section-information.vue